import { Box, Column, Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import appQrImage from '~/images/appQrCode.png';
import storeQrImage from '~/images/storeQrCode.png';

export interface IProfessionalsTabProps {
  /**
   * `signup` (default): QR opens the App Store / Google Play to download GoTu.
   * `login`: QR deep-links into the installed GoTu app for account access.
   */
  variant?: 'signup' | 'login';
}

const COPY = {
  signup:
    'Scan this QR code with your phone to open the App Store or Google Play and download the GoTu app.',
  login: 'Scan this QR code with your phone to open the GoTu app and access your account.',
} as const;

const TITLE = {
  signup: 'Welcome, Professionals!',
  login: 'Welcome Back, Professionals!',
} as const;

const IMAGES = {
  signup: { src: storeQrImage, alt: 'QR code to download the GoTu mobile app' },
  login: { src: appQrImage, alt: 'QR code to open the GoTu mobile app' },
} as const;

export const ProfessionalsTab = ({ variant = 'signup' }: IProfessionalsTabProps = {}) => {
  const { src, alt } = IMAGES[variant];

  return (
    <Box data-testid="professionals-tab">
      <Column pt={6} gap={12}>
        <Typography bold size="heading_3" color={colors.primary[500]}>
          {TITLE[variant]}
        </Typography>
        <Row align="start" gap={5} wrap="nowrap" pl={10}>
          {/* DS Typography drops inline maxWidth — wrapper enforces the cap. */}
          <Box style={{ maxWidth: 239 }}>
            <Typography size="body_large_tight" color={colors.neutral[500]}>
              {COPY[variant]}
            </Typography>
          </Box>
          <img
            src={src}
            alt={alt}
            width={90}
            height={90}
            style={{ flexShrink: 0, mixBlendMode: 'multiply' }}
          />
        </Row>
      </Column>
    </Box>
  );
};
